module.exports = __webpack_public_path__ + "static/media/virtualCloset.5dbf80eb.gif";